function NoContent(props) {
	return (
		<section className='mt-6 form-alert form-alert-grey w-fit'>
			<h3 className='title'>{props.title}</h3>

			<section className='rich-text text mt-1'>
				<p>{props.message}</p>
			</section>
		</section>
	);
}

export default NoContent;
